import { fonts } from '~/src/helpers/font';
import { EElementType, ILandingElement } from '~/src/services/projects';

export const ImageTextBlock: ILandingElement = {
    title: 'ImageTextBlock',
    type: EElementType.Block,
    label: 'Текстовый блок с изображениями',
    properties: {
        blockName: '',
        customStyles: '',
        sortOrder: '',
        background: '',
        backgroundWebp: '',
        marginTop: '',
        marginBottom: '',
        blockWidth: '',
    },
    children: [
        {
            title: 'Title',
            type: EElementType.RTE,
            label: 'Заголовок',
            properties: {
                customize: {
                    font: fonts.H1,
                    color: '#1A1A1A',
                    textAlign: 'left',
                    tag: '',
                },
                htmlContent: 'Заголовок',
                customStyles: 'white-space: pre-wrap;',
            },
        },
        {
          title: 'SubTitle',
          type: EElementType.RTE,
          label: 'Подзаголовок',
          properties: {
            customize: {
              font: fonts.XXL,
              color: '#1A1A1A',
              textAlign: 'left',
              tag: '',
            },
            htmlContent: 'Подзаголовок',
            customStyles: '',
          },
        },
        {
            title: 'Text',
            type: EElementType.RTE,
            label: 'Текст',
            properties: {
                customize: {
                    font: fonts.S,
                    color: '#1A1A1A',
                    textAlign: 'left',
                },
                htmlContent: '<p>Текст...</p>',
                customStyles: '',
            },
        },
        {
            title: 'LeftImage',
            type: EElementType.Image,
            label: 'Изображение слева',
            properties: {
                content: '',
                webp: '',
                alt: '',
                customStyles: '',
            },
        },
        {
            title: 'RightImage',
            type: EElementType.Image,
            label: 'Изображение справа',
            properties: {
                content: '',
                webp: '',
                alt: '',
                customStyles: '',
            },
        },
        {
          title: 'Button',
          type: EElementType.Button,
          label: 'Кнопка',
          properties: {
            customStyles: '',
            isTargetBlank: false,
          },
          children: [
            {
              title: 'Text',
              type: EElementType.Text,
              label: 'Текст',
              properties: {
                customize: {
                  font: fonts.Medium,
                  color: '#FFF',
                  href: '',
                },
                content: 'Кнопка',
                customStyles: '',
              },
            },
          ],
        },
    ],
};
